import { enqueueSnackbar, UploadFile } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';

import {
	GetSiteTrackerTableRequest,
	CreateSiteEntryRequest,
	EditSiteEntryRequest,
	GetSiteTrackerDropdownsRequest,
	GetSiteTrackerBSHDropdownRequest,
	GetSiteTrackerBSHDropdownWlcsRequest,
	GetSiteTrackerSiteNameDropdownRequest,
	GetSiteTrackerRequest,
	GetSiteTrackerToEditRequest,
	GetCommentsHistoryRequest,
	GetExportTrackerRequest,
	GetSiteTrackerDasZoneDropdownRequest,
	ImportSiteTrackerRequest,
	ExportSiteTrackerTemplateRequest,
	RemoveSiteEntryRequest,
	GetReportEmailRequest,
	GetSiteTypeDropdownRequest,
	GetSiteTrackerUpdateTableRequest,
	UpdateSiteActivationDatesRequest,
	GetSiteTrackerLcsCreateTableRequest,
	CreateNewSiteTrackerEntriesRequest
} from '../requests/SiteTrackerRequests';

export const TOGGLE_SITE_TRACKER_DIALOG = 'TOGGLE_SITE_TRACKER_DIALOG';
export const GET_SITE_TRACKER_TABLE = 'GET_SITE_TRACKER_TABLE';
export const SET_FORM_STATE = 'SET_FORM_STATE';
export const GET_DROPDOWNS = 'GET_DROPDOWNS';
export const GET_BSH_DROPDOWN = 'GET_BSH_DROPDOWN';
export const GET_SITE_NAME_DROPDOWN = 'GET_SITE_NAME_DROPDOWN';
export const GET_SITE_DASZONE_DROPDOWN = 'GET_SITE_DASZONE_DROPDOWN';
export const GET_SITE_TRACKER = 'GET_SITE_TRACKER';
export const GET_SITE_TRACKER_TO_EDIT = 'GET_SITE_TRACKER_TO_EDIT';
export const GET_COMMENTS_HISTORY = 'GET_COMMENTS_HISTORY';
export const TOGGLE_IMPORT_MODAL_VISIBILITY = 'TOGGLE_IMPORT_MODAL_VISIBILITY';
export const GET_SITE_TYPE_DROPDOWN = 'GET_SITE_TYPE_DROPDOWN';
export const GET_SITE_TRACKER_UPDATE_TABLE = 'GET_SITE_TRACKER_UPDATE_TABLE';
export const GET_SITE_TRACKER_CREATE_LCS_TABLE = 'GET_SITE_TRACKER_CREATE_LCS_TABLE';
export const TOGGLE_SITE_TRACKER_UPDATE_VISIBILITY = 'TOGGLE_SITE_TRACKER_UPDATE_VISIBILITY';
export const TOGGLE_SITE_TRACKER_LCS_CREATE_VISIBILITY = 'TOGGLE_SITE_TRACKER_LCS_CREATE_VISIBILITY';

const onToggleSiteTrackerDialog = (visible, siteTrackerId) => ({
	type: TOGGLE_SITE_TRACKER_DIALOG,
	visible,
	siteTrackerId
});

export const ToggleSiteTrackerDialog = (visible, siteTrackerId) => (dispatch) => {
	dispatch(onToggleSiteTrackerDialog(visible, siteTrackerId));
};

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

const onGetSiteTrackerTable = (value) => ({
	type: GET_SITE_TRACKER_TABLE,
	siteTrackerTable: value
});

export const GetSiteTrackerTable = () => async (dispatch) => {
	await GetSiteTrackerTableRequest().then(response => {
		dispatch(onGetSiteTrackerTable(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetSiteTrackerUpdateTable = (value) => ({
	type: GET_SITE_TRACKER_UPDATE_TABLE,
	siteTrackerUpdateTable: value
});

export const GetSiteTrackerUpdateTable = () => async (dispatch) => {
	await GetSiteTrackerUpdateTableRequest().then(response => {
		dispatch(onGetSiteTrackerUpdateTable(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onToggleSiteTrackerUpdateVisibility = (visible) => ({
	type: TOGGLE_SITE_TRACKER_UPDATE_VISIBILITY,
	siteTrackerUpdateVisibility: visible
});

export const ToggleSiteTrackerUpdateVisibility = (visible) => (dispatch) => {
	dispatch(onToggleSiteTrackerUpdateVisibility(visible));
};

const onGetSiteTrackerLcsCreateTable = (value) => ({
	type: GET_SITE_TRACKER_CREATE_LCS_TABLE,
	siteTrackerCreateLCSTable: value
});

export const GetSiteTrackerLcsCreateTable = () => async (dispatch) => {
	await GetSiteTrackerLcsCreateTableRequest().then(response => {
		dispatch(onGetSiteTrackerLcsCreateTable(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onToggleSiteTrackerLcsCreateVisibility = (visible) => ({
	type: TOGGLE_SITE_TRACKER_LCS_CREATE_VISIBILITY,
	siteTrackerLCSCreateVisibility: visible
});

export const ToggleSiteTrackerLcsCreateVisibility = (visible) => (dispatch) => {
	dispatch(onToggleSiteTrackerLcsCreateVisibility(visible));
};

export const CreateSiteEntry = (siteTrackerCreateDto) => async (dispatch) => {
	await CreateSiteEntryRequest(siteTrackerCreateDto).then(response => {
		dispatch(enqueueSnackbar({ message: 'Entry successfully created.', options: { variant: 'success' } }));
		dispatch(GetSiteTrackerTable());
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const EditSiteEntry = (siteTrackerForm) => async (dispatch) => {
	await EditSiteEntryRequest(siteTrackerForm).then(response => {
		dispatch(enqueueSnackbar({ message: 'Entry successfully edited.', options: { variant: 'success' } }));
		dispatch(GetSiteTrackerTable());
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetDropdowns = (value) => ({
	type: GET_DROPDOWNS,
	dropdowns: value
});

export const GetDropdowns = () => async (dispatch) => {
	await GetSiteTrackerDropdownsRequest().then(response => {
		dispatch(onGetDropdowns(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetCommentsHistory = (value, valueType) => ({
	type: GET_COMMENTS_HISTORY,
	commentsHistory: value,
	commentType: valueType
});

export const GetCommentsHistory = (id, commentType) => async (dispatch) => {
	await GetCommentsHistoryRequest(id, commentType).then(response => {
		dispatch(onGetCommentsHistory(response.data, commentType));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetBshDropdownWlcs = (value) => ({
	type: GET_BSH_DROPDOWN,
	siteBshDropdown: value
});

export const GetBshDropdownWlcs = (lcs) => async (dispatch) => {
	await GetSiteTrackerBSHDropdownWlcsRequest(lcs).then(response => {
		dispatch(onGetBshDropdownWlcs(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetBshDropdown = (value) => ({
	type: GET_BSH_DROPDOWN,
	siteBshDropdown: value
});

export const GetBshDropdown = () => async (dispatch) => {
	await GetSiteTrackerBSHDropdownRequest().then(response => {
		dispatch(onGetBshDropdown(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetSiteTypeDropdown = (value) => ({
	type: GET_SITE_TYPE_DROPDOWN,
	siteTypeDropdown: value
});

export const GetSiteTypeDropdown = (lcs) => async (dispatch) => {
	await GetSiteTypeDropdownRequest(lcs).then(response => {
		dispatch(onGetSiteTypeDropdown(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetSiteNameDropdown = (value) => ({
	type: GET_SITE_NAME_DROPDOWN,
	siteNameDropdown: value
});

export const GetSiteNameDropdown = (siteLCS, siteType) => async (dispatch) => {
	await GetSiteTrackerSiteNameDropdownRequest(siteLCS, siteType).then(response => {
		dispatch(onGetSiteNameDropdown(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetSiteDasZoneDropdown = (value) => ({
	type: GET_SITE_DASZONE_DROPDOWN,
	siteDasZoneDropdown: value
});

export const GetSiteDasZoneDropdown = (siteLCS, siteBSH, siteType) => async (dispatch) => {
	await GetSiteTrackerDasZoneDropdownRequest(siteLCS, siteBSH, siteType).then(response => {
		dispatch(onGetSiteDasZoneDropdown(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetSiteTracker = (value) => ({
	type: GET_SITE_TRACKER,
	siteTracker: value
});

export const GetSiteTracker = (id) => async (dispatch) => {
	await GetSiteTrackerRequest(id).then(response => {
		dispatch(onGetSiteTracker(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetSiteTrackerToEdit = (value) => ({
	type: GET_SITE_TRACKER_TO_EDIT,
	siteTracker: value
});

export const GetSiteTrackerToEdit = (id) => async (dispatch) => {
	await GetSiteTrackerToEditRequest(id).then(response => {
		dispatch(onGetSiteTrackerToEdit(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetExportTracker = () => async (dispatch) => {
	await GetExportTrackerRequest().then(response => {
		dispatch(DownloadFile(response.data));
		dispatch(enqueueSnackbar({ message: 'Tracker successfully exported.', options: { variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ImportSiteTracker = (siteTrackerFilePath, user) => async (dispatch) => {
	await ImportSiteTrackerRequest(siteTrackerFilePath, user).then(response => {
		dispatch(GetSiteTrackerTable());
		dispatch(enqueueSnackbar({ message: 'Tracker successfully imported.', options: { variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onToggleImportModalVisibility = (visible) => ({
	type: TOGGLE_IMPORT_MODAL_VISIBILITY,
	importModalVisibility: visible
});

export const ToggleImportModalVisibility = (visible) => (dispatch) => {
	dispatch(onToggleImportModalVisibility(visible));
};

export const UploadTrackerFiles = (file, user) => async (dispatch) => {
	await UploadFile(file, user).then(response => {
		dispatch(ImportSiteTracker(response.data, user));
		dispatch(ToggleImportModalVisibility(false));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ExportSiteTrackerTemplate = () => async (dispatch) => {
	await ExportSiteTrackerTemplateRequest().then(response => {
		dispatch(DownloadFile(response.data));
		dispatch(ToggleImportModalVisibility(true));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const RemoveSiteEntry = (id, user) => async (dispatch) => {
	await RemoveSiteEntryRequest(id, user).then(response => {
		dispatch(enqueueSnackbar({ message: 'Entry successfully removed.', options: { variant: 'success' } }));
		dispatch(GetSiteTrackerTable());
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetReportEmail = (id, user) => async (dispatch) => {
	await GetReportEmailRequest(id, user).then(response => {
		dispatch(DownloadFile(response.data));
		dispatch(enqueueSnackbar({ message: 'Report successfully downloaded.', options: { variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const UpdateSiteActivationDates = (siteIdsToUpdate) => async (dispatch) => {
	await UpdateSiteActivationDatesRequest(siteIdsToUpdate).then(response => {
		dispatch(enqueueSnackbar({ message: 'LCS activation dates updated.', options: { variant: 'success' } }));
		dispatch(GetSiteTrackerUpdateTable());
		dispatch(GetSiteTrackerTable());
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const CreateNewSiteTrackerEntries = (lcsToCreate) => async (dispatch) => {
	await CreateNewSiteTrackerEntriesRequest(lcsToCreate).then(response => {
		dispatch(enqueueSnackbar({ message: 'New SiteTracker entries created.', options: { variant: 'success' } }));
		dispatch(GetSiteTrackerLcsCreateTable());
		dispatch(GetSiteTrackerTable());
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
